var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconReviewInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3L0 20H6.9L10.708 23.218C11.069 23.5231 11.5264 23.6905 11.999 23.6905C12.4716 23.6905 12.929 23.5231 13.29 23.218L17.1 20H24V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.31607 21.7956 0 21 0V0ZM22 18H16.366L12 21.69L7.634 18H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V18Z",
    fill: "#A9B1C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.00024H6V7.00024H12V5.00024Z",
    fill: "#A9B1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H6V11H18V9Z",
    fill: "#A9B1C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.9998H6V14.9998H18V12.9998Z",
    fill: "#A9B1C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconReviewInactive);
export default __webpack_public_path__ + "static/media/menu_icon_review_inactive.c723eefd46da62e94dd4f9cf3f1712d7.svg";
export { ForwardRef as ReactComponent };